import ThumbnailListItem from "./ThumbnailListItem";
import { IThumbnailList } from "./interfaces";
import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import FaChevronDown from "../SVG/Fontawesome/FaChevronDown";
import { useRouter } from "next/router";

const ThumbnailList = (props: IThumbnailList) => {
  const items = props.items;
  const [count, updateCount] = useState(4);
  const router = useRouter();
  
  useEffect(() => {
    if(!isMobile) return;
    updateCount(items.length);
  }, []);
  
  const childrenItems = items.slice(0, count);

  return <section id="toppers">
    {props.title && <h3 className="text-inherit">{props.title}</h3>}

    <div className={`snap-x flex sm:grid grid-cols-2 sm:justify-center items-center overflow-x-auto sm:overflow-x-hidden sm:flex-wrap gap-4 ${router.pathname == "/VideoPage" ? "!grid-cols-1" : ""}  ${props.className ?? ""}`}>
      { childrenItems.map((item, index) => (
        <ThumbnailListItem key={index.toString()} item={item}/>
      ))}
    </div>
    {
      count < items.length &&
        <button className="block mt-4 mx-auto" onClick={(_)=>updateCount(previousCount => previousCount + 2)}>
            View More <FaChevronDown className="text-inherit"/>
        </button>
    }
  </section>   
};

export default ThumbnailList;